// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Settings: React.FC = () => {
    return <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 42 42" enableBackground="new 0 0 42 42" xmlSpace="preserve">
<path fillRule="evenodd" clipRule="evenodd" d="M36.48,23.04c0.08-0.67,0.15-1.33,0.15-2.04c0-0.71-0.06-1.38-0.15-2.04l4.4-3.44
	c0.4-0.31,0.5-0.88,0.25-1.33l-4.17-7.21c-0.25-0.46-0.81-0.62-1.27-0.46L30.5,8.6c-1.08-0.83-2.25-1.52-3.52-2.04l-0.79-5.52
	c-0.06-0.5-0.5-0.88-1.02-0.88h-8.33c-0.52,0-0.96,0.38-1.02,0.88l-0.79,5.52c-1.27,0.52-2.44,1.23-3.52,2.04L6.31,6.52
	c-0.48-0.19-1.02,0-1.27,0.46l-4.17,7.21c-0.27,0.46-0.15,1.02,0.25,1.33l4.4,3.44C5.44,19.62,5.38,20.31,5.38,21
	s0.06,1.38,0.15,2.04l-4.4,3.44c-0.4,0.31-0.5,0.88-0.25,1.33l4.17,7.21c0.25,0.46,0.81,0.62,1.27,0.46l5.19-2.08
	c1.08,0.83,2.25,1.52,3.52,2.04l0.79,5.52c0.06,0.5,0.5,0.88,1.02,0.88h8.33c0.52,0,0.96-0.38,1.02-0.88l0.79-5.52
	c1.27-0.52,2.44-1.23,3.52-2.04l5.19,2.08c0.48,0.19,1.02,0,1.27-0.46l4.17-7.21c0.25-0.46,0.15-1.02-0.25-1.33L36.48,23.04z
	 M21,28.29c-4.02,0-7.29-3.27-7.29-7.29c0-4.02,3.27-7.29,7.29-7.29s7.29,3.27,7.29,7.29C28.29,25.02,25.02,28.29,21,28.29z"/>
</svg>;
};

export default React.memo(Settings);
